import CmsModelState from '../_util/cms-model';

class CMSCategoriesState extends CmsModelState {
  get url() { return '/categories'; }
  get singular() { return 'category'; }
  get plural() { return 'categories'; }
}

export default CMSCategoriesState;



// WEBPACK FOOTER //
// ./spa/state/cms/cms-categories.jsx